import type { Redirect } from '../../../../main/types/links';
import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_IOS_REDIRECT = 'UPDATE_QR_CODE_LINK_IOS_REDIRECT' as const;

export const updateQrCodeLinkIosRedirect = (iosRedirect: Redirect) => ({
  data: { iosRedirect },
  type: UPDATE_QR_CODE_LINK_IOS_REDIRECT,
});

export type UpdateQrCodeLinkIosRedirectResponseAction = DataAction<
  typeof UPDATE_QR_CODE_LINK_IOS_REDIRECT,
  { iosRedirect: Redirect }
>;
